import { ACOMPANHAMENTO_TERRITORIO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import image from 'images/gestao-cadastros/mudanca-acompanhamento-territorio.svg'
import MudancaPathRedirectView from 'view/gestao-cadastros/MudancaPathRedirectView'

export default function AcompanhamentoTerritorioRedirectView() {
  return (
    <MudancaPathRedirectView
      titulo='O território mudou de lugar!'
      texto='Agora você pode acessar o acompanhamento do território na seção de Gestão de cadastros do menu principal.'
      textoBotao='Acessar Acompanhamento do território'
      path={ACOMPANHAMENTO_TERRITORIO_PATH}
      image={image}
    />
  )
}
